export const SITE = {
  name: "Grupo Nexus",
  domain: "www.gruponexus.tec.br",
  email: "contato@gruponexus.tec.br",
  phoneRaw: "5516981845736",
  phoneLabel: "+55 (16) 98184-5736",
  whatsappUrl:
    "https://wa.me/5516981845736?text=" +
    encodeURIComponent(
      "Olá, Grupo Nexus! Gostaria de falar com a equipe sobre uma solução."
    ),
  mapsUrl: "https://maps.app.goo.gl/VAMdtoAyLtWkjwM79",
  coords: { lat: -21.784825, lng: -48.196314 },
  mapsEmbedSrc:
    "https://www.google.com/maps?q=-21.784825,-48.196314&hl=pt-BR&z=16&output=embed",
  socials: {
    instagram: "https://www.instagram.com/nexusconectados/",
    facebook: "https://www.facebook.com/profile.php?id=61571574577009",
  },
  logo: "/assets/nexus-logo.png",
};

export const NAV_ITEMS = [
  { id: "inicio", label: "Início" },
  { id: "grupo", label: "Grupo" },
  { id: "empresas", label: "Empresas" },
  { id: "solucoes", label: "Soluções" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "depoimentos", label: "Depoimentos" },
  { id: "contato", label: "Contato" },
];

export const UNITS = [
  {
    id: "infra",
    name: "Infraestrutura Técnica",
    tagline: "Engenharia de redes e data centers",
    description:
      "Fusão e certificação de fibra óptica, instalações de data centers, lançamento de cabos de fibra e UTP, montagem e organização de racks, estruturação de redes e apoio completo a projetos de infraestrutura tecnológica.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/45876ead-02aa-42fd-bdbd-b2c7f606006c/images/ffee4e28c0ab598b7a4eb09798d58c27474667942f1f5b5dff0cc462a17910e3.png",
    bullets: [
      "Fusão e certificação de fibra óptica",
      "Instalações de data centers",
      "Lançamento de cabos fibra e UTP",
      "Montagem e organização de racks",
      "Estruturação de redes corporativas",
      "Empreita técnica",
    ],
    link: "/infraestrutura",
    external: false,
  },
  {
    id: "nexus-internet",
    name: "Nexus Internet",
    tagline: "Conectividade de alta performance",
    description:
      "Fibra óptica para residências, condomínios e empresas — velocidade estável, suporte próximo e infraestrutura em expansão contínua.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/45876ead-02aa-42fd-bdbd-b2c7f606006c/images/0e96aec0917c41999454dbfcdeaf9321f6dcc3d47283710aeb5f21a658a8abe9.png",
    bullets: ["Planos para casa, condomínio e empresa", "Rede redundante", "Suporte técnico especializado"],
    link: "/internet",
    external: false,
  },
  {
    id: "vision",
    name: "Vision",
    tagline: "Monitoramento & segurança eletrônica",
    description:
      "Câmeras, gravação, gestão visual e instalações de segurança — soluções integradas para controle e acompanhamento em tempo real.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/45876ead-02aa-42fd-bdbd-b2c7f606006c/images/10795e68b47dc5b41e03046c537ff4218d752d3ec1aeed0983d5e12fb9408192.png",
    bullets: ["CFTV HD/4K", "Gravação e gestão em nuvem", "Projetos sob medida"],
    link: "https://cam.gruponexus.tec.br",
    external: true,
  },
  {
    id: "monal",
    name: "Monal",
    tagline: "Inovação digital com propósito",
    description:
      "Startup do grupo voltada a experiências digitais: memoriais com QR Code, soluções interativas e projetos de tecnologia aplicada.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/45876ead-02aa-42fd-bdbd-b2c7f606006c/images/00932952799ae3aa474fa87f58e02f68d664f448a13cb2a39bc645fdccd48181.png",
    bullets: ["Memoriais digitais via QR", "Experiências interativas", "Projetos especiais"],
    link: "https://monal.com.br/",
    external: true,
  },
];

export const DIFERENCIAIS = [
  {
    icon: "Layers",
    title: "Ecossistema integrado",
    desc: "Conectividade, segurança, infraestrutura e inovação sob uma única governança técnica.",
  },
  {
    icon: "Wrench",
    title: "Expertise em execução",
    desc: "Engenharia e operação próprias — do projeto à entrega, sem depender de terceiros.",
  },
  {
    icon: "Headphones",
    title: "Atendimento próximo",
    desc: "Equipe regional com resposta rápida, visitas técnicas e SLA transparente.",
  },
  {
    icon: "Building2",
    title: "Do home ao corporativo",
    desc: "Projetos dimensionados para residências, condomínios e ambientes empresariais.",
  },
  {
    icon: "Sparkles",
    title: "Inovação aplicada",
    desc: "Soluções digitais reais (Monal) que agregam valor, emoção e diferenciação.",
  },
  {
    icon: "Expand",
    title: "Escalabilidade sob medida",
    desc: "Projetos personalizados com capacidade de expansão e crescimento planejado.",
  },
];

export const SOLUCOES = {
  infraestrutura: {
    label: "Infraestrutura Técnica",
    accent: "yellow",
    items: [
      { title: "Fusão e certificação de fibra", desc: "Emenda óptica profissional com certificação OTDR de backbone." },
      { title: "Instalação de data centers", desc: "Projeto, montagem e ativação completa de ambientes críticos." },
      { title: "Lançamento de fibra e UTP", desc: "Passagem, organização e identificação do cabeamento estruturado." },
      { title: "Montagem de racks", desc: "Organização profissional com documentação as-built." },
      { title: "Estruturação de redes", desc: "LAN corporativo e Wi-Fi de alta densidade." },
      { title: "Suporte à infraestrutura", desc: "Manutenção e evolução contínua da operação." },
    ],
  },
  conectividade: {
    label: "Conectividade",
    accent: "cyan",
    items: [
      { title: "Internet fibra óptica", desc: "Planos residenciais e corporativos com latência baixa." },
      { title: "Soluções para condomínios", desc: "Projetos chave-na-mão com gestão centralizada." },
      { title: "Estrutura de rede", desc: "Projetos de LAN/Wi-Fi corporativo de alta densidade." },
      { title: "Expansão de cobertura", desc: "Engenharia para ampliação planejada da rede." },
    ],
  },
  seguranca: {
    label: "Segurança & Monitoramento",
    accent: "magenta",
    items: [
      { title: "Câmeras de monitoramento", desc: "Tecnologia HD e 4K com visão noturna." },
      { title: "Gravação e gestão visual", desc: "Armazenamento local e em nuvem com gestão unificada." },
      { title: "Instalações de segurança", desc: "Projeto, passagem de cabos e ativação completa." },
      { title: "Soluções integradas", desc: "Para condomínios e empresas com múltiplos sites." },
    ],
  },
  inovacao: {
    label: "Inovação Digital",
    accent: "purple",
    items: [
      { title: "Soluções com QR Code", desc: "Memoriais digitais e experiências dinâmicas." },
      { title: "Experiências Monal", desc: "Projetos digitais com propósito emocional." },
      { title: "Tecnologia aplicada", desc: "Projetos especiais sob demanda." },
      { title: "Integração de serviços", desc: "Unificação de camadas digitais e físicas." },
    ],
  },
};

export const TESTIMONIALS = [
  {
    unit: "Nexus Internet",
    quote:
      "Migramos todo o condomínio para a Nexus e a diferença na estabilidade foi imediata. Suporte humano e rápido.",
    author: "Camila Souza",
    role: "Síndica de condomínio — Araraquara",
  },
  {
    unit: "Vision",
    quote:
      "O projeto de CFTV foi dimensionado com precisão. A integração com os sistemas existentes funcionou sem atritos.",
    author: "Rodrigo Almeida",
    role: "Gestor de segurança",
  },
  {
    unit: "Monal",
    quote:
      "O memorial digital com QR superou expectativas: simples, emocionante e bem construído tecnicamente.",
    author: "Juliana Martins",
    role: "Cliente Monal",
  },
  {
    unit: "Infraestrutura",
    quote:
      "Racks organizados, documentação impecável e a equipe respeitou cada detalhe do cronograma da obra.",
    author: "Felipe Andrade",
    role: "Engenheiro responsável",
  },
  {
    unit: "Nexus Internet",
    quote:
      "Atendimento de verdade. Nunca tive um problema que não fosse resolvido no mesmo dia.",
    author: "Bruno Oliveira",
    role: "Cliente residencial",
  },
  {
    unit: "Vision",
    quote:
      "A implantação foi organizada e discreta. O resultado elevou o padrão de segurança da operação.",
    author: "Mariana Costa",
    role: "Coordenadora de operações",
  },
];

export const METRICAS = [
  { value: "04", label: "Unidades de negócio", sub: "Ecossistema integrado" },
  { value: "100%", label: "Operação própria", sub: "Projeto, obra e suporte" },
  { value: "24/7", label: "Monitoramento", sub: "Resposta imediata" },
  { value: "∞", label: "Escalabilidade", sub: "Projetos sob medida" },
];
